/**
 * @generated SignedSource<<b277d733fbbd93e2f411176b2768118a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicHeaderTopic$data = {
  readonly mobileImage: {
    readonly alt: string | null | undefined;
    readonly style: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly title: string | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly sponsor: {
    readonly " $fragmentSpreads": FragmentRefs<"sponsorTagSponsor">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"entityFollowButtonBase" | "hooksTopic" | "topicHeaderRelatedLinksTopic">;
  readonly " $fragmentType": "topicHeaderTopic";
};
export type topicHeaderTopic$key = {
  readonly " $data"?: topicHeaderTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicHeaderTopic">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicHeaderTopic",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "topicHeaderRelatedLinksTopic"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityFollowButtonBase"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "hooksTopic",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "types",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Sponsor",
          "kind": "LinkedField",
          "name": "sponsor",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "alias": "mobileImage",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "MOBILE_APP_IMAGE"
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "alt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "300x300"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": "style(filter:{\"style\":\"300x300\"})"
        }
      ],
      "storageKey": "image(type:\"MOBILE_APP_IMAGE\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Sponsor",
      "kind": "LinkedField",
      "name": "sponsor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "sponsorTagSponsor"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Topic",
  "abstractKey": null
};

(node as any).hash = "889c4f1a724cd4a1a1d3c023c6830c99";

export default node;
